import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/user.slice";
import eventReducer from "./slices/event.slice";
import validationReducer from "./slices/validation.slice";
import geoLocationReducer from "./slices/geolocation.slice";
import bankListReducer from "./slices/banklist.slice";
import workspaceReducer from "./slices/workspace.slice";
import editEventReducer from "./slices/eventedit.slice";
export const store = configureStore({
  reducer: {
    user: userReducer,
    event: eventReducer,
    validation: validationReducer,
    geolocation: geoLocationReducer,
    workspace: workspaceReducer,
    banklist: bankListReducer,
    eventEdit: editEventReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
